import { ProjectDocTypeVals } from "./ProjectDocTypes";

export const projectDocTypeAbbreviations: Record<number, string> = {
  [ProjectDocTypeVals.TS]:           `ТЗ`,
  [ProjectDocTypeVals.TSC]:          `Изм ТЗ`,
  [ProjectDocTypeVals.PD]:           `ПД`,
  [ProjectDocTypeVals.PDEdit]:       `Изм ПД`,
  [ProjectDocTypeVals.WD]:           `РД`,
  [ProjectDocTypeVals.WDEdit]:       `Изм РД`,
  [ProjectDocTypeVals.II]:           `ИИ`,
  [ProjectDocTypeVals.IIEdit]:       `Изм ИИ`,
  [ProjectDocTypeVals.OriginalData]: `ИсхД`,
  [ProjectDocTypeVals.IPA]:          `ИРД`,
  [ProjectDocTypeVals.IPAEdit]:      `Изм ИРД`,
  [ProjectDocTypeVals.Executive]:    `ИД`,
};
